module.exports = "/assets/data/f515aba3ccabac4f236195029f9990d5-KA7.data.json";